// gsap register plugin
//gsap.registerPlugin(ScrollTrigger);

class SlideProduct {
  constructor(el) {
    this._el = el;
    this._productsImgThumbs = [
      ...this._el.querySelectorAll(".vpm-slide-product-thumb-image"),
    ];
    this._productsImgs = [
      ...this._el.querySelectorAll(".vpm-slide-product-image"),
    ];
    this._productsColors = [
      ...this._el.querySelectorAll(".vpm-slide-product-color"),
    ];
    this._productsPrices = [
      ...this._el.querySelectorAll(".vpm-slide-product-price"),
    ];
    // bindings
    this._handleHoverProductImgThumb =
      this._handleHoverProductImgThumb.bind(this);
    this.init();
  }

  init() {
    for (var i = 0; i < this._productsImgThumbs.length; i++) {
      this._productsImgThumbs[i].addEventListener("mouseenter", (event) => {
        this._handleHoverProductImgThumb(
          this._productsImgThumbs.indexOf(event.target)
        );
      });
    }
  }

  _handleHoverProductImgThumb = (index) => {
    const currentProductEls = [
      ...this._el.querySelectorAll(".vpm-slide-product-current"),
    ];

    currentProductEls.forEach((el) => {
      el.classList.remove("vpm-slide-product-current");
    });
    this._productsImgs[index].classList.add("vpm-slide-product-current");
    this._productsColors[index].classList.add("vpm-slide-product-current");
    this._productsPrices[index].classList.add("vpm-slide-product-current");
    this._productsImgThumbs[index].classList.add("vpm-slide-product-current");
  };

  destroy() {
    this._el = null;
  }
}

const productsImgWrapper = [
  ...document.querySelectorAll('[data-component="SlideProduct"]'),
];

for (let i = 0; i < productsImgWrapper.length; i++) {
  new SlideProduct(productsImgWrapper[i]);
}

const homeBackgrounds = gsap.utils.toArray('[data-component="Background"]');
const homeForegrounds = gsap.utils.toArray('[data-component="Foreground"]');
/*gsap
  .from(homeBackgrounds[1], {
    scale: 0.3,
    scrollTrigger: {
      trigger: homeForegrounds[1],
      scrub: true,
      pin: true,
    },
  })
  .from(homeForegrounds[1], {
    color: "#ffffff",
    scrollTrigger: {
      trigger: homeForegrounds[1],
      scrub: true,
      pin: true,
    },
  });*/
//let tl = gsap.timeline({scrollTrigger: {start: "top center"}});
// //gsap.from(homeBackgrounds[1], {});
// const boxes = gsap.utils.toArray('[data-component="Background"]');
// boxes.forEach((box) => {
//   gsap.from(box, {
//     scale: 0.3,
//     scrollTrigger: {
//       trigger: box,
//       scrub: true,
//     },
//   });
// });
